import React from 'react';
import { FormattedMessage } from 'react-intl';


const CardComparisonRatehubSection = {
    sectionId: 'ratehub',
    sectionLabel: (
        <FormattedMessage
            id="edb.cc.side-by-side-v2.ratehub-take"
            defaultMessage="Ratehub’s Take"
        />
    ),
    items: [
        {
            cardPropertyKey: 'reviewRating',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.ratehub-rating"
                    defaultMessage="Ratehub Rating"
                />
            ),
        },
        {
            cardPropertyKey: 'ratehubReview',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.ratehub-take"
                    defaultMessage="Ratehub’s Take"
                />
            ),
        },
    ],
};

export default CardComparisonRatehubSection;
